import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

export async function fetchAlerts({ unreadOnly = false, category = null, limit = 30, skip = 0 } = {}) {
  const params = { limit, skip };
  if (unreadOnly) params.unread_only = true;
  if (category) params.category = category;
  const { data } = await client.get('/api/admin/alerts', { params });
  return data;
}

export async function fetchUnreadCount(category = null) {
  const params = category ? { category } : {};
  const { data } = await client.get('/api/admin/alerts/unread-count', { params });
  return data;
}

export async function markAlertRead(alertId) {
  const { data } = await client.post(`/api/admin/alerts/${alertId}/read`);
  return data;
}

export async function markAllAlertsRead() {
  const { data } = await client.post('/api/admin/alerts/read-all');
  return data;
}

export async function dismissAlert(alertId) {
  const { data } = await client.post(`/api/admin/alerts/${alertId}/dismiss`);
  return data;
}

export async function fetchAlertPreferences() {
  const { data } = await client.get('/api/admin/alerts/preferences');
  return data.preferences;
}

export async function updateAlertPreferences(prefs) {
  const { data } = await client.put('/api/admin/alerts/preferences', prefs);
  return data.preferences;
}

/** Opt in to browser push for every alert severity (info, warning, critical). */
export async function enablePushAllAlerts() {
  return updateAlertPreferences({
    channels: { in_app: true, push: true, email: false },
    push_all_alerts: true,
    min_push_severity: 'info',
  });
}
